// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#userIcon+.v-btn i{font-size:20px!important;padding:1em!important;border-radius:50%!important;background-color:#27846d!important;color:#fff!important;font-style:normal!important}", ""]);
// Exports
module.exports = exports;
